export default function branchAuthHeader() {
    const branchToken = JSON.parse(localStorage.getItem('branchToken'));

    if (branchToken) {
        return { Authorization: 'Bearer ' + branchToken };
    } else {
        return {};
    }
}